import React , {Component} from 'react';
import {checkPermission} from "../../utils/methods";
import {LandingFooterPanelV2, Layout, NavigationBarV2, PlatformEngagementPage} from "../../components";
import PropTypes from "prop-types";
class Engagement extends Component{
  render() {
    const { history } = this.props;
    const authToken = (checkPermission() && localStorage && localStorage.getItem('AUTH_TOKEN')) ? true : false;
    return (
      <Layout>
        <NavigationBarV2
          history={history}
          showInternalLinks={false}
          isUser={authToken}
        />
        <PlatformEngagementPage  history={history}/>
        <LandingFooterPanelV2 isUser={authToken} />
      </Layout>
    );
  }
}

Engagement.propTypes = {
  history: PropTypes.object
}
export default Engagement;